var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-left px-1 px-md-2",attrs:{"id":"vendor-profile-page"}},[_c('h3',{staticClass:"mb-3"},[_vm._v("Exhibitor Profile")]),(!!_vm.company)?_c('vendor-profile-comp',{ref:"profile_editor",attrs:{"company":_vm.company,"after_save_action":_vm.after_save}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }